import React, { useEffect, useState } from 'react';

export default function CouponBox(props) {
  //console.log(props)

  // coupontype = 3 정액 / 4 정률 / 6: S상품, VOD상품
  const [fymd, setFymd] = useState('');

  useEffect(() => {
    const fymd = remainDays(props.fymd);
    setFymd(fymd);

    closeHandler();
  }, [props]);

  const remainDays = (fymd) => {
    const endDate = new Date(fymd);
    const today = new Date();
    const timeDiff = endDate.getTime() - today.getTime();
    const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    const daysRemainingStr = (daysRemaining <= 0 ? 0 : daysRemaining).toString();
    return daysRemainingStr;
  };

  const detailHandler = () => {
    const coupon = document.querySelector(`#coupon-${props.couponno}`);
    if (coupon) {
      coupon.classList.add('viewDetail');
    }
  };

  const closeHandler = () => {
    const coupon = document.querySelector(`#coupon-${props.couponno}`);
    if (coupon) {
      coupon.classList.remove('viewDetail');
    }
  };
  try {
    return (
      <>
        <div id={`coupon-${props.couponno}`} className={`couponModule_type${props.coupontype === '3' ? 'Price' : props.coupontype === '4' ? 'Percent' : props.coupontype === '6' ? 'Event' : 'Price'} ${props.tabType === 'expire' ? props.couponstatus == '1' ? 'expireDate' : 'alreadyUse' : ''}`}>{/*<!-- 뒷면 보려면 viewDetail 추가 couponModule_typePrice, Percent, Event -->*/}
          <div className="couponModule_card">
            <div className="couponModuleCard_Front">
              <a href="#none" className="couponModuleCard-link">
                <div className="couponModuleCard-Title">
                  <span className="couponModuleCard-TitleText">{props.couponname1 || ''}</span>
                  {props.tabType === 'hold' && (
                    <strong className="couponModuleCard-TitleDday">
                      D-{fymd || ''}
                    </strong>
                  )}
                </div>
                <em className="couponModuleCard-BigTitle">{props.coupontypem || ''}</em>
                <p className="couponModuleCard-info">사용기간 : {props.symd || ''} - {props.fymd || ''}</p>
              </a>
              <button type="button" className="couponModuleCard-more" onClick={detailHandler}>자세히보기</button>
            </div>
            <div className="couponModuleCard_Back">
              <strong className="couponModuleCard-Title">{props.couponname2 || ''}</strong>

              <p className="couponModuleCard-text">
                {props.usemaxprice && props.usemaxprice !== '0' && props.usemaxprice !== 0
                  ? props.coupontype !== '6'
                    ? `최대 할인금액: ${props.usemaxprice}원`
                    : ''
                  : ''}
              </p>

              <strong className="couponModuleCard-noticeTitle">유의사항</strong>
              <ul className="couponModuleCard-noticeList">
                <li className="couponModuleCard-noticeText">
                  {props.coupondesc
                    ? props.coupondesc
                      .split(/<\/?br\s*\/?>(\r\n|\n|\r)?/i)
                      .filter(line => line && line.trim())
                      .map((line, index) => (
                        <React.Fragment key={index}>
                          {line.trim()}
                          <br />
                        </React.Fragment>
                      ))
                    : ''}
                </li>
              </ul>
              <button type="button" className="couponModuleCard-BtnClosed" onClick={closeHandler}><span className="iconSvg_closed"><i className="hide">닫기</i></span></button>
            </div>
          </div>
        </div>
      </>
    );
  } catch (error) {
    return (<></>);
  }
}